import { render, staticRenderFns } from "./Server.vue?vue&type=template&id=604b8c4a&scoped=true"
import script from "./Server.vue?vue&type=script&lang=js"
export * from "./Server.vue?vue&type=script&lang=js"
import style0 from "./Server.vue?vue&type=style&index=0&id=604b8c4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "604b8c4a",
  null
  
)

export default component.exports